import PropTypes from "prop-types";
import React from "react";
import CompliancePieChart from "./CompliancePieChart";
import ComplianceSummaryCard from "./ComplianceSummaryCard";

const SUMMARY_ORDER = ["compliant", "notDue", "due", "notCompliant"];

const ComplianceSummaryGrid = ({ summary, counts, showChart, caption }) => {
  const safeSummary = summary || {};
  const safeCounts = counts || {};

  return (
    <div className="space-y-6">
      <div className="grid gap-3 md:grid-cols-4">
        {SUMMARY_ORDER.map((statusKey) => (
          <ComplianceSummaryCard
            key={statusKey}
            statusKey={statusKey}
            count={safeCounts[statusKey] || 0}
          />
        ))}
      </div>
      {showChart !== false && (
        <div className="border-t border-gray-100 pt-6">
          <CompliancePieChart summary={safeSummary} />
          {caption ? (
            <p className="mt-3 text-xs text-gray-500">{caption}</p>
          ) : null}
        </div>
      )}
    </div>
  );
};

ComplianceSummaryGrid.propTypes = {
  summary: PropTypes.shape({
    compliant: PropTypes.number,
    notDue: PropTypes.number,
    due: PropTypes.number,
    notCompliant: PropTypes.number,
  }),
  counts: PropTypes.shape({
    compliant: PropTypes.number,
    notDue: PropTypes.number,
    due: PropTypes.number,
    notCompliant: PropTypes.number,
  }),
  showChart: PropTypes.bool,
  caption: PropTypes.string,
};

ComplianceSummaryGrid.defaultProps = {
  summary: undefined,
  counts: undefined,
  showChart: true,
  caption: undefined,
};

export default ComplianceSummaryGrid;
